import React from 'react';

import { AlertTriangleIcon, SuccessStatusIcon, SyncIcon } from 'common/components/core/icons';
import { TaskStatus } from 'common/components/TasksWidget/queries';
import './TaskStatusIcon.scss';

export const failedStatus = [TaskStatus.FAILED, TaskStatus.FAILING, TaskStatus.CANCELLED, TaskStatus.CANCELLING];
const successStatus = [TaskStatus.DONE, TaskStatus.SUCCEEDING];

export function TaskStatusIcon({ status }: { status?: TaskStatus }) {
  if (!!status && successStatus.includes(status)) {
    return (
      <div>
        <SuccessStatusIcon className="task-status-icon__success" />
      </div>
    );
  }
  if (!!status && failedStatus.includes(status)) {
    return (
      <div>
        <AlertTriangleIcon className="task-status-icon__failed" />
      </div>
    );
  }
  return (
    <div>
      <SyncIcon className="task-status-icon__running" />
    </div>
  );
}
